/**
 * 燈箱內容
 * id: 該物件id
 * title: 標題
 * content: 內容，可接受html tag
 * confirmButton: 主色按鈕文字，undefined時不出現
 * isErrorButton: 主色按鈕是 true:紅色 false|undefined:藍綠色
 * cancelButton: 灰色按鈕文字，undefined時不出現
 * closeicon: 是否顯示右上角關閉叉叉按鈕
*/
const dialogContnet = {
    remove: {
        id: 'remove',
        title: '請確認',
        content: '確定刪除此筆資料？',
        confirmButton: '確定',
        isErrorButton: true,
        cancelButton: '取消',
        closeicon: false,
    },
    validateMsg: {
        title: '提示',
        content: '輸入資料不完整/有誤，請確認輸入欄位下方之紅色提示文字。',
        confirmButton: '確認',
        cancelButton: null,
        closeicon: true,
    },
    validEmptyMsg: {
        title: '提示',
        content: '請輸入欄位資料',
        confirmButton: '確認',
        cancelButton: null,
        closeicon: true,
    },
    leave: {
        title: '請確認',
        content: '您的變更申請尚未完成，若離開此頁面，將需要重新申請。請確認是否離開正在進行中的申請流程？',
        confirmButton: '離開',
        cancelButton: '取消',
        closeicon: false,
        isErrorButton: true,
    },
    leaveA3A4A5: {
        title: '請確認',
        content: '您的給付帳號約定作業尚未完成，離開此頁面，若欲重新申請，請再以通知單上之連結路徑登入。提醒您，若您是投保外幣保單限匯款給付，敬請務必回覆約定帳號，以避免延誤給付予您的時間。',
        confirmButton: '離開',
        cancelButton: '取消',
        closeicon: false,
        isErrorButton: true,
    },
    reApply: {
        title: '很抱歉',
        content: '系統忙碌中，請您稍後再試。',
        confirmButton: '離開',
        closeicon: false,
        isErrorButton: true,
    },
    refresh: {
        title: '很抱歉',
        content: '資料發生錯誤，請重新確認。',
        confirmButton: '刷新',
        closeicon: false,
        isErrorButton: true,
    },
};

Object.freeze(dialogContnet);
export default dialogContnet;
